import { Button, Grid2 } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import DashboardLayout from "layouts/DashboardLayout";
import { TbArrowBackUp } from "react-icons/tb";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import BrokerPreference from "./BrokerPreference";
import Dividend from "./Dividend";
import WalletTopup from "./WalletTopup";

const Preference = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, refetch, isFetched } = useQuery({
    queryKey: ["GET_BROKER"],
    queryFn: () =>
      axiosInstance.get(`/super_admin/${id}/get_broker_integration_status/`),
  });

  return (
    <DashboardLayout
      title="Preference"
      toolbar={
        <Button size="extraSmall" onClick={() => navigate(-1)}>
          Back &nbsp; <TbArrowBackUp />
        </Button>
      }
    >
      <Grid2 container spacing={1}>
        <Grid2 size={12}>
          <BrokerPreference
            data={data}
            isFetched={isFetched}
            refetch={refetch}
          />
        </Grid2>
        <Grid2 size={12}>
          <Dividend data={data} isFetched={isFetched} refetch={refetch} />
        </Grid2>
        <Grid2 size={12}>
          <WalletTopup />
        </Grid2>
      </Grid2>
    </DashboardLayout>
  );
};

export default Preference;
